const routerArr = [
    {
      path: '/userMessageList',
      name: 'userMessage',
      meta: { title:'我的消息',login:true },
      component: () => import(/* webpackChunkName: 'trainTest' */ './page/messageList.vue'),
    },
    {
        path: '/userMessageDetail',
        name: 'userMessageDetail',
        meta: { title:'我的消息',login:true },
        component: () => import(/* webpackChunkName: 'trainTest' */ './page/userMessageDetail.vue'),
      }
    
  ]
  export default routerArr